import { render, staticRenderFns } from "./NavigationDrawer.vue?vue&type=template&id=480fb75a&scoped=true"
import script from "./NavigationDrawer.vue?vue&type=script&lang=js"
export * from "./NavigationDrawer.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawer.vue?vue&type=style&index=0&id=480fb75a&prod&scoped=true&lang=css"
import style1 from "./NavigationDrawer.vue?vue&type=style&index=1&id=480fb75a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480fb75a",
  null
  
)

export default component.exports